import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo11 } from "../../../routes/Module11";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo11/noticias.png";
import Imagen2 from "../../../images/modulo11/denuncia.png";
import Imagen3 from "../../../images/modulo11/sentencia.png";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import InputRadioButton from "../../../components/InputRadioButton";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo11/Actividad 4.mp3";

const Actividad4 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "option2" },
    ans2: { value: "", valid: "", correctValue: "option2" },
    ans3: { value: "", valid: "", correctValue: "option1" },
  });
  const infoUnidad = modulo11.content[0];
  const infoAct = modulo11.content[0].activities[3];
  const crumbs = [
    {
      title: modulo11.title,
      url: "/" + modulo11.url,
    },
    {
      title:
        modulo11.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo11.content[0].activities[4].name}`,
    linkNext: `${modulo11.url}/${modulo11.content[0].path}/${modulo11.content[0].activities[4].path}`,
    titlePrev: `${modulo11.content[0].activities[2].name}`,
    linkPrev: `${modulo11.url}/${modulo11.content[0].path}/${modulo11.content[0].activities[2].path}`,
  };

  const metadata = {
    color: modulo11.color,
    title: `${modulo11.title} - ${infoAct.name}`,
    name: modulo11.title,
  };

  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"] === answers[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...answers, newAnswers });
  };
  const handleAnswer = (label, value) => {
    setAnswers({
      ...answers,
      [label]: { ...answers[label], value },
    });
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo11.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul>
        <li>
          Observa las siguientes viñetas. Presta atención a las palabras
          destacadas.
        </li>
        <li>
          Marca el significado correcto de cada una de las palabras destacadas.
        </li>
      </ul>

      <Card>
        <div className="row align-items-center">
          <div className="col-md-6 col-12">
            <img src={Imagen1} alt="Ministra" className="img-fluid" />
          </div>
          <div className="col-md-6 col-12">
            <InputRadioButton
              ans={answers.ans1}
              label="ans1"
              value="option1"
              text="Reunión de jueces para revisar la Constitución."
              handleAnswer={handleAnswer}
            />
            <InputRadioButton
              ans={answers.ans1}
              label="ans1"
              value="option2"
              text="Proceso en el que los jueces determinan si el comportamiento de
              alguien va en contra de la ley."
              handleAnswer={handleAnswer}
            />
          </div>
        </div>
      </Card>

      <Card>
        <div className="row align-items-center">
          <div className="col-md-6 col-12">
            <img src={Imagen2} alt="Ministra" className="img-fluid" />
          </div>
          <div className="col-md-6 col-12">
            <InputRadioButton
              ans={answers.ans2}
              label="ans2"
              value="option1"
              text="Criticar a una persona delante de otra."
              handleAnswer={handleAnswer}
            />
            <InputRadioButton
              ans={answers.ans2}
              label="ans2"
              value="option2"
              text="Comunicar a una autoridad algo que está fuera de la ley."
              handleAnswer={handleAnswer}
            />
          </div>
        </div>
      </Card>
      <Card>
        <div className="row align-items-center">
          <div className="col-md-6 col-12">
            <img src={Imagen3} alt="Ministra" className="img-fluid" />
          </div>
          <div className="col-md-6 col-12">
            <InputRadioButton
              ans={answers.ans3}
              label="ans3"
              value="option1"
              text="Decisión de un juez que sanciona a los que comenten delitos y
              faltas."
              handleAnswer={handleAnswer}
            />
            <InputRadioButton
              ans={answers.ans3}
              label="ans3"
              value="option2"
              text="Opinión de un juez."
              handleAnswer={handleAnswer}
            />
          </div>
        </div>
      </Card>

      <div className="row my-4">
        <div className="col-md-12">
          <button
            className={`btn float-end btn-${modulo11.color}`}
            onClick={validateAnswers}
          >
            Enviar respuestas
          </button>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Observen las imágenes y lean los textos de las viñetas. Para cada una
          de las palabras propuestas (juicio, denuncia, sentencia) se proponen
          dos significados; deberán marcar el significado correcto. Resalte que
          el significado de la palabra lo pueden inferir a partir de la viñeta.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
